/**
 * MOCK · CANONICAL (CT-5286) — the tabs a Unified Profile opens with.
 *
 * Overview is NOT in here. It is the one invariant of the screen, guaranteed by
 * the frontend, so a tabs outage still leaves a usable profile. Everything
 * returned below is additional and entirely tenant-shaped.
 *
 * The seed exists to prove the claim, so the three types differ in every way
 * that matters:
 *
 *   customers  one extra tab
 *   vehicles   two extra tabs — the Garage / Appointments case from the call
 *   employees  none: Overview only, and the profile still works
 *
 * Overview is the only tab that paints a dashboard of widgets, and the frontend
 * owns that. Most dynamic tabs are a LIST — data with filters and search —
 * and Activity (CT-5527) is the one designed feed, kind ACTIVITY. Customers also
 * get Tasks (CT-5722), Intelligence (CT-5715) and Knowledge (CT-5717), placed
 * before History as in the UCP v2.1 prototype.
 *
 * `unsupported` is deliberate. The backend will ship a kind before the frontend
 * knows it, and the screen has to survive that rather than crash.
 */

const SEED_TABS = {
  customers: [
    { tab_id: 'tasks', label: 'Tasks', kind: 'TASKS' },
    { tab_id: 'intelligence', label: 'Intelligence', kind: 'INTELLIGENCE' },
    { tab_id: 'knowledge', label: 'Knowledge', kind: 'KNOWLEDGE' },
    // Renamed to History by CT-5724; the id and the kind stay.
    { tab_id: 'activity', label: 'History', kind: 'ACTIVITY' },
  ],
  companies: [{ tab_id: 'activity', label: 'Activity', kind: 'LIST' }],
  vehicles: [
    { tab_id: 'garage', label: 'Garage', kind: 'LIST' },
    { tab_id: 'appointments', label: 'Appointments', kind: 'LIST' },
    { tab_id: 'telemetry', label: 'Telemetry', kind: 'TIMESERIES_NOT_BUILT_YET' },
  ],
  employees: [],
  dealerships: [],
};

const buildSeed = () => JSON.parse(JSON.stringify(SEED_TABS));

let mockProfileTabs = buildSeed();

export const getMockProfileTabs = () => mockProfileTabs;

/** Test-only: reset the mutable seed between tests within a file. */
export const __resetMockProfileTabsForTests = () => {
  mockProfileTabs = buildSeed();
};
